import { DpEventBus } from '@/core/events/DpEventBus';
import type { DpEvent } from '@/core/events/DpEvent';
import { injectable } from 'tsyringe';
import type { EventPublisher } from './EventPublisher';

@injectable()
export class BusEventPublisher implements EventPublisher {
  constructor(private readonly eventBus: DpEventBus) {}

  send(event: DpEvent): void {
    this.eventBus.publish(event);
  }
}
